export const unorderedListType = ['disc', 'circle', 'square', 'tick', 'none', 'unordered'];

export const remarkData = {
    list: {
        items: ['KFS_REMARKS_1', 'KFS_REMARKS_2', 'KFS_REMARKS_3', 'KFS_REMARKS_4', 'KFS_REMARKS_5', 'KFS_REMARKS_6'],
        listType: 'ordered',
    }
}

export const illustrativeData = {
    list: {
        items: [
            'KFS_ILLUSTRATIVE_TABLE_ASSUMPTIONS_1',
            'KFS_ILLUSTRATIVE_TABLE_ASSUMPTIONS_2',
            'KFS_ILLUSTRATIVE_TABLE_ASSUMPTIONS_3',
            'KFS_ILLUSTRATIVE_TABLE_ASSUMPTIONS_4',
            'KFS_ILLUSTRATIVE_TABLE_ASSUMPTIONS_5',
        ],
        listType: 'disc',
    },
    table: {
        header: ['KFS_ILLUSTRATIVE_TABLE_CONTENT1', 'KFS_ILLUSTRATIVE_TABLE_CONTENT4', 'KFS_ILLUSTRATIVE_TABLE_CONTENT7'],
        body: [
            ['KFS_ILLUSTRATIVE_TABLE_CONTENT2', 'KFS_ILLUSTRATIVE_TABLE_CONTENT5', 'KFS_ILLUSTRATIVE_TABLE_CONTENT8'],
            ['KFS_ILLUSTRATIVE_TABLE_CONTENT3', 'KFS_ILLUSTRATIVE_TABLE_CONTENT6', 'KFS_ILLUSTRATIVE_TABLE_CONTENT9'],
        ]
    }
}

// KFS table data. the content type=p|l|t, p->paragraph, l->list, t->table
export const kfsTableData = {
    header: ['KFS_DESC1', 'KFS_DESC2', 'KFS_DESC3'],
    body: [
        {
            title: "KFS_INTEREST_RATES_AND_CHARGES"
        },
        {
            key: "KFS_IR_RETAIL_PURCHASE",
            value: [
                { type: "p", content: "KFS_IR_RETAIL_PURCHASE_CONTENT1" },
                { type: "p", content: "KFS_IR_RETAIL_PURCHASE_CONTENT2" }
            ]
        },

        {
            key: "KFS_IR_CASH_ADVANCE",
            value: [
                { type: "p", content: "KFS_IR_CASH_ADVANCE_CONTENT1" },
                { type: "p", content: "KFS_IR_CASH_ADVANCE_CONTENT2" },
            ]
        },
        {
            key: "KFS_APR_RETAIL_PURCHASE",
            value: [
                { type: "p", content: "KFS_APR_RETAIL_PURCHASE_CONTENT1" },
                { type: "p", content: "KFS_APR_RETAIL_PURCHASE_CONTENT2" },
                {
                    type: "l",
                    listType: "lower-alpha",
                    items: ['KFS_APR_RETAIL_PURCHASE_CONTENT3', 'KFS_APR_RETAIL_PURCHASE_CONTENT4']
                }
            ]
        },
        {
            key: "KFS_APR_CASH_ADVANCE",
            value: [
                { type: "p", content: "KFS_APR_CASH_ADVANCE_CONTENT1" },
                { type: "p", content: "KFS_APR_CASH_ADVANCE_CONTENT2" },
                {
                    type: "l",
                    listType: "lower-alpha",
                    items: ['KFS_APR_CASH_ADVANCE_CONTENT3', 'KFS_APR_CASH_ADVANCE_CONTENT4']
                }
            ]
        },
        {
            key: "KFS_DELINQUNENT_APR",
            value: [
                { type: "p", content: "KFS_DELINQUNENT_APR_CONTENT" },
            ]
        },
        {
            key: "KFS_IFP",
            value: [
                { type: "p", content: "KFS_IFP_CONTENT" },
            ]
        },
        {
            key: "KFS_MINIMUM_PAYMENT",
            value: [
                {
                    type: "t",
                    content: {
                        header: ['KFS_CARD_TYPE', 'KFS_MINIMUM_PAYMENT_DUE'],
                        body: [
                            ['KFS_MINIMUM_PAYMENT_CARD_TYPE1', {
                                type: "l",
                                items: [
                                    'KFS_MINIMUM_PAYMENT_DUE_CONTENT1_1',
                                    'KFS_MINIMUM_PAYMENT_DUE_CONTENT1_2',
                                ],
                                listType: 'lower-roman',
                            }],
                            ['KFS_MINIMUM_PAYMENT_CARD_TYPE2', {
                                type: "l",
                                items: [
                                    'KFS_MINIMUM_PAYMENT_DUE_CONTENT2_1',
                                    'KFS_MINIMUM_PAYMENT_DUE_CONTENT2_2',
                                ],
                                listType: 'lower-roman',
                            }],
                            ['KFS_MINIMUM_PAYMENT_CARD_TYPE3', 'KFS_MINIMUM_PAYMENT_DUE_CONTENT3'],
                        ]
                    }
                }
            ]
        },
        {
            title: 'KFS_FEES'
        },
        {
            key: "KFS_ANNUAL_FEE",
            value: [
                { type: "p", content: "KFS_ANNUAL_FEE_CONTENT" },
                {
                    type: "t",
                    content: {
                        header: ['KFS_CARD_TYPE', 'KFS_ANNUAL_FEE_PRIMARY_CARD', 'KFS_ANNUAL_FEE_ADDITIONAL_CARD_SEPARATE', 'KFS_ANNUAL_FEE_ADDITIONAL_CARD_COMBINED'],
                        body: [
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD'],
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD_TYPE1', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_WAIVED', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_WAIVED'],
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD_TYPE2', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_WAIVED', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_WAIVED'],
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD_TYPE3', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD2000', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD1000'],
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD_TYPE4', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD2000', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE'],
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD_TYPE5', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD1800', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD900'],
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD_TYPE6', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD600', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD600', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD300'],
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD_TYPE7', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD300', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD300', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD150'],
                            ['KFS_ANNUAL_FEE_HKCREDIT_CARD_TYPE8', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD300', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE'],
                            ['KFS_ANNUAL_FEE_FOREIGN_CREDIT_CARD'],
                            ['KFS_ANNUAL_FEE_FOREIGN_CREDIT_CARD_TYPE1', 'KFS_ANNUAL_FEE_FOREIGN_CREDIT_CARD_USD80', 'KFS_ANNUAL_FEE_FOREIGN_CREDIT_CARD_USD80', 'KFS_ANNUAL_FEE_FOREIGN_CREDIT_CARD_USD40'],

                            ['KFS_ANNUAL_FEE_UNIONPAY_CREDIT_CARD'],
                            ['KFS_ANNUAL_FEE_UNIONPAY_CREDIT_CARD_TYPE1', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD1800', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD900'],
                            ['KFS_ANNUAL_FEE_UNIONPAY_CREDIT_CARD_TYPE2', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD300', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_NOT_APPLICABLE', 'KFS_ANNUAL_FEE_HKCREDIT_CARD_HKD150'],
                        ],
                    }
                }
            ]
        },
        {
            key: "KFS_CASH_ADVANCE_FEE",
            value: [
                { type: "p", content: "KFS_CASH_ADVANCE_FEE_CONTENT1" },
                { type: "p", content: "KFS_CASH_ADVANCE_FEE_CONTENT2" },
                {
                    type: "l",
                    listType: "disc",
                    items: ['KFS_CASH_ADVANCE_FEE_CONTENT3', 'KFS_CASH_ADVANCE_FEE_CONTENT4']
                },
                { type: "p", content: "KFS_CASH_ADVANCE_FEE_CONTENT5" },
                {
                    type: "l",
                    listType: "disc",
                    items: ['KFS_CASH_ADVANCE_FEE_CONTENT6', 'KFS_CASH_ADVANCE_FEE_CONTENT7']
                }
            ]
        },
        {
            key: "KFS_FOREIGN_TRANSCTION_FEE",
            value: [
                { type: "p", content: "KFS_FOREIGN_TRANSCTION_FEE_CONTENT1" },
                { type: "p", content: "KFS_FOREIGN_TRANSCTION_FEE_CONTENT2" },
                { type: "p", content: "KFS_FOREIGN_TRANSCTION_FEE_CONTENT3" },
                { type: "p", content: "KFS_FOREIGN_TRANSCTION_FEE_CONTENT4" },
            ]
        },
        {
            key: "KFS_RELATING_FOREIGN_TRANSCTION_FEE",
            value: [
                { type: "p", content: "KFS_RELATING_FOREIGN_TRANSCTION_FEE_CONTENT1" },
                { type: "p", content: "KFS_RELATING_FOREIGN_TRANSCTION_FEE_CONTENT2" },
                { type: "p", content: "KFS_RELATING_FOREIGN_TRANSCTION_FEE_CONTENT3" },
                { type: "p", content: "KFS_RELATING_FOREIGN_TRANSCTION_FEE_CONTENT4" },
                { type: "p", content: "KFS_RELATING_FOREIGN_TRANSCTION_FEE_CONTENT5" },
                { type: "p", content: "KFS_RELATING_FOREIGN_TRANSCTION_FEE_CONTENT6" },
            ]
        },
        {
            key: "KFS_LATE_PAYMENT_FEE",
            value: [
                {
                    type: "l",
                    listType: "disc",
                    items: ['KFS_LATE_PAYMENT_FEE_CONTENT1', 'KFS_LATE_PAYMENT_FEE_CONTENT2', 'KFS_LATE_PAYMENT_FEE_CONTENT3']
                },
                { type: "p", content: "KFS_LATE_PAYMENT_FEE_CONTENT4" },
            ]
        },
        {
            key: "KFS_OVER_THE_LIMIT_FEE",
            value: [
                { type: "p", content: "KFS_OVER_THE_LIMIT_FEE_CONTENT1" },
                { type: "p", content: "KFS_OVER_THE_LIMIT_FEE_CONTENT2" },
                {
                    type: "l",
                    listType: "disc",
                    items: ['KFS_OVER_THE_LIMIT_FEE_CONTENT3', 'KFS_OVER_THE_LIMIT_FEE_CONTENT4', 'KFS_OVER_THE_LIMIT_FEE_CONTENT5', 'KFS_OVER_THE_LIMIT_FEE_CONTENT6']
                },
                { type: "p", content: "KFS_OVER_THE_LIMIT_FEE_CONTENT7" },
                {
                    type: "l",
                    listType: "disc",
                    items: ['KFS_OVER_THE_LIMIT_FEE_CONTENT8', 'KFS_OVER_THE_LIMIT_FEE_CONTENT9', 'KFS_OVER_THE_LIMIT_FEE_CONTENT10']
                },
                { type: "p", content: "KFS_OVER_THE_LIMIT_FEE_CONTENT11" },
            ]
        },
        {
            key: "KFS_RETURNED_PAYMENT_FEE",
            value: [
                { type: "p", content: "KFS_RETURNED_PAYMENT_FEE_CONTENT1" },
                {
                    type: "l",
                    listType: "disc",
                    items: ['KFS_RETURNED_PAYMENT_FEE_CONTENT2', 'KFS_RETURNED_PAYMENT_FEE_CONTENT3', 'KFS_RETURNED_PAYMENT_FEE_CONTENT4']
                }
            ]
        },
        {
            key: "KFS_BILL_PAYMENT_HANDING_FEE",
            value: [
                { type: "p", content: "KFS_BILL_PAYMENT_HANDING_FEE_CONTENT" }
            ]
        },
        {
            key: "KFS_ANNUAL_PAPER_STATEMENT_FEE",
            value: [
                { type: "p", content: "KFS_ANNUAL_PAPER_STATEMENT_FEE_CONTENT1" },
                {
                    type: "l",
                    listType: "disc",
                    items: ['KFS_ANNUAL_PAPER_STATEMENT_FEE_CONTENT2', 'KFS_ANNUAL_PAPER_STATEMENT_FEE_CONTENT3']
                }
            ]
        },

    ]
}